import React from 'react';
import Login from './pages/login/login';

const App = () => (
  <div className="homeLogin">
    <Login />
  </div>
);
export default App;
